import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import {
  ACCEPTABLE_FILE_TYPES,
  FILENAME_REGEX,
  MAX_NUM_FILES,
} from '../../configuration'
import './fileupload.css'
import InputLabel from '../../utils/controls/input-label'
import { FileError } from '../../shared/types'
import { validateFile, DocumentIconNames } from '../../Global'
import Alert from '../alert/alert'
interface Props {
  onFileChange: any
  label?: any
  hint?: any
  inputProps?: any
  infoClassName?: any
  info?: any
  infoIcon?: any
  isInfo?: any
  formClassName?: any
  files?: any
  setFiles?: any
  disabled?: any
  hintClassName?: any
  hintTextClassName?: any
  note?: any
  noteClassName?: any
  error?: any
  mandatory?: any
  setFileError?: any
  fileError?: boolean
  labelClassName?:any
  data?: any
}
interface Item {
  name?: string;
  file_name?: string;
}
export const FileUpload = (props: Props) => {
  const wrapperRef = useRef<any>(null)
  const [fileList, setFileList] = useState<any>(
    props?.files ? props?.files : []
  )
  const onDragEnter = () => wrapperRef.current.classList.add('dragover')
  const onDragLeave = () => wrapperRef.current.classList.remove('dragover')
  const { setFiles, label, info, isInfo, hint, files } = props
  const [dragActive, setDragActive] = useState<boolean>(false)
  const [fileErrors, setFileErrors] = useState<Array<FileError>>([])
  const [showAlert, setShowAlert] = useState(false)
  const [showAlert1, setShowAlert1] = useState(false)
  const [existingFiles, setExistingFiles] = useState<string[]>()
  const [newFiles, setNewFiles] = useState<Array<File>>([])
  const [deleteDecision, setDeleteDecision] = useState<boolean>()
  const [deleteItem, setDeleteItem] = useState(null)
  const [validatedFiles, setValidatedFiles] = useState<Array<File>>([])
  useEffect(() => {
    setFileList(props?.files)
    if (props?.files?.length === 0) {
      setFileErrors([])
    }
  }, [props?.files])
  const addFileHandler = () => {
    document.getElementById('attachFile')!
  }
  const checkFilesAlreadyExist = (newFiles: Array<File>): Array<string> => {
    const existingFiles: Array<string> = []
    newFiles.forEach((file: File) => {
      if ( files?.filter( (f: any) => (f?.name ? f?.name : f?.file_name) === file.name  )?.length > 0) {
        existingFiles.push(file.name)
      }
      else if( props?.data?.filter( (f: any) => (f?.file_name) === file.name  )?.length > 0){
        existingFiles.push(file.name)
      }
    })
    return existingFiles
  }
  const validateFiles = (files: Array<File>): [boolean, Array<FileError>] => {
    let valid = true
    const errors: Array<FileError> = []
    files?.forEach((file: File) => {
      const [fileValid, error] = validateFile(file, ACCEPTABLE_FILE_TYPES)
      if (!fileValid) {
        valid = false
        errors.push(...error)
      }
    })
    return [valid, errors]
  }
  const onRespondClick = (userDecision: string) => {
    let newFileItem: Array<File> = []
    if (userDecision === 'Replace') {
      setFiles((prevFiles: any[]) =>
        prevFiles
          .filter(
            (file: any) =>
              !existingFiles?.includes(file?.name ? file?.name : file?.file_name)
          )
          ?.concat(validatedFiles)
      )
      setFileList((prevFiles: any[]) =>
        prevFiles
          .filter(
            (file: any) =>
              !existingFiles?.includes(file?.name ? file?.name : file?.file_name)
          )
          ?.concat(validatedFiles)
      )
      setShowAlert(false)
    } else {
      newFileItem = validatedFiles?.filter(
        (file: any) =>
          !existingFiles?.includes(file?.name ? file?.name : file?.file_name)
      )
      setFiles(files.concat(newFileItem))
      setFileList(files.concat(newFileItem))
      setShowAlert(false)
    }
  }
  const handleFileUploadChange = (e: any, type: 'Click' | 'Drag') => {
    e.preventDefault()
    setFileErrors([])
    let newFiles: Array<File> = Array.from(
      type === 'Click' ? e.target.files : e.dataTransfer.files
    )
    setNewFiles(newFiles)
    const [valid, errors] = validateFiles(newFiles)
    const validatedFiles = newFiles?.filter((newFile: any) => {
      return !errors.some(
        (invalidFile) => invalidFile.fileName === newFile.name
      )
    })
    setValidatedFiles(validatedFiles)
    const existingFiles: string[] = checkFilesAlreadyExist(validatedFiles)
    setExistingFiles(existingFiles)

    if (
      files.length > MAX_NUM_FILES ||
      newFiles.length > MAX_NUM_FILES ||
      newFiles.length + files.length > MAX_NUM_FILES
    ) {
      setFileErrors((prevErrors) => [
        ...prevErrors,
        {
          fileName: 'Max file upload limit exceeded',
          message: `Maximum of ${MAX_NUM_FILES} files can be uploaded.`,
        },
      ])
      return
    }
    if (!valid) {
      errors.map((error: FileError) =>
        setFileErrors((prevErrors) => [
          ...prevErrors,
          { fileName: error.fileName, message: error.message },
        ])
      )
      newFiles = newFiles.filter(
        (file: File) =>
          !errors.map((error: FileError) => error.fileName).includes(file.name)
      )
    }
    if (existingFiles.length > 0) {
      setShowAlert(true)
      return
    }
    if (newFiles.length > 0) {
      setFiles(files.concat(newFiles))
      setFileList(files.concat(newFiles))
    }
    if (props?.onFileChange) {
      props?.onFileChange(files.concat(newFiles))
    }
    e.target.value = null
  }

  // triggers when file is selected with click
  const onFileDrop = (e: any) => {
    e.preventDefault()
    if (e.target.files && e.target.files[0]) {
      handleFileUploadChange(e, 'Click')
    }
    e.target.value = null
  }

  // triggers when file is dropped
  const handleDrop = (e: any) => {
    e.preventDefault()
    setDragActive(false)
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFileUploadChange(e, 'Drag')
    }
  }
  const handleDrag = (e: any) => {
    e.preventDefault()
    e.stopPropagation()
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true)
    } else if (e.type === 'dragleave') {
      setDragActive(false)
    }
  }
  useEffect(() => {
    setShowAlert1(false)
  },[deleteDecision])

  const fileRemove = (file:any) => {
    setDeleteItem(file)
    setShowAlert1(true) 
  }

  const onClickAlert = async (button: string) => {
        if (!props?.disabled) {
      if (button === 'YES') {
        const updatedList = [...fileList]
        updatedList.splice(fileList.indexOf(deleteItem), 1)
        setFileList(updatedList)
        setFiles(updatedList)
        if (updatedList?.length === 0 && props?.setFileError) {
          props?.setFileError(false)
        }
        if (props?.onFileChange) {
          props?.onFileChange(updatedList)
        }
        setShowAlert1(false)
      }else{
        setShowAlert1(false)
      }
    }
  }
  return (
    <>
      <div className='attachments w-100'>
        <div className='formgroup poppins-medium font-12'>
          {/* <label htmlFor='form-file-upload'>Attach File(s) </label> */}
          {props?.label && (
            <InputLabel
              labelProps={{ htmlFor: 'form-file-upload' }}
              label={props?.label}
              labelClassName={props?.inputProps?.labelClassName}
              infoLabel={props?.info}
              isinfoLabel={props?.isInfo}
              isinfoIcon={props?.infoIcon}
              isinfoClassName={props?.infoClassName}
              mandatory={props?.mandatory}
            />
          )}
          <div
            id='form-file-upload'
            className='attachfile dropzonecontrol'
            tabIndex={0}
            aria-label='Attach Files section'
          >
            <div
              ref={wrapperRef}
              className='drop-file-input'
              onDragEnter={onDragEnter}
              onDragLeave={onDragLeave}
              onDragOver={(e) => e.preventDefault()}
              onDrop={(e) => handleDrop(e)}
            >
              <label
                htmlFor='attachFile'
                title='Choose/Drag Files'
                className='choosebtn sourcesansprosemibold'
                onClick={addFileHandler}
              >
                Choose/Drag Files
              </label>
              <input
                type='file'
                name='Choose/Drag Files'
                title='Choose/Drag Files'
                id='attachFile'
                // accept='.xlsx,.XLSX,.xls,.XLS,.doc,.DOC,.docx,.DOCX,.ppt,.PPT,.pptx,.PPTX,.txt,.TXT,.pdf,.PDF,.png,.PNG,.jpg,.JPG,.jpeg,.JPEG,.gif,.GIF,.msg,.MSG'
                accept = '.pdf,.PDF'
                aria-label='Choose or Drag files'
                multiple
                onInput={onFileDrop}
                disabled={!!props?.disabled}
              />
              {fileList?.length > 0 ? (
                <div className='attachmentsdisplay'>
                  <ul id='attachments' className='formattach'>
                    {fileList.map((item: any, index: number) => (
                      <li key={item.name}>
                        <div
                          className='attachedfiles'
                          title={item.name ? item.name : item.file_name ? item.file_name : item.Name}
                          tabIndex={0}
                          aria-label={item.name ? item.name : item.file_name ? item.file_name : item.Name}
                        >
                        <span className={`me-1 ${DocumentIconNames(item.name ? item.name : item.file_name ? item.file_name : item.Name)}`}></span>
                          {item.name || item.Name || item.file_name}
                          <span
                            className='icon-close'
                            onClick={() => fileRemove(item)}
                            onKeyDown={(e) => {e.key == 'Enter' ? fileRemove(item) : ''}}
                            title='Close'
                            tabIndex={0}
                            aria-label='Cancel'
                          ></span>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : null}
              {dragActive && (
                <div
                  id='drag-file-element'
                  onDragEnter={handleDrag}
                  onDragLeave={handleDrag}
                  onDragOver={handleDrag}
                  onDrop={handleDrop}
                ></div>
              )}
              {fileErrors?.length > 0 && <Alert
                                    className="alert-info"
                                    message={<div>
                                      {fileErrors?.map((error: FileError, index: number) => (
                                      <div key={index} className='error-item'>
                                        <div className='error-filename'>{error.fileName}</div>
                                      </div>
                                    ))}
                                    <div>
                                      {fileErrors[0].message}</div>
                                    </div>
                                  }
                                    alerttextclass="poppins-semibold font-12 text-center"
                                    yes="OK"
                                    btn1className='btn-xs btn-border-radius3 btn-primary whitetext px-2  poppins-semibold font-12'
                                    btn1iconclassName="icon-checked font-12 me-1"
                                    onClick={() => {setFileErrors([])}}
                                  />
                                  }
              {props?.error && props?.fileError && fileList?.length == 0 && (
                <div className='drop-file-input'>
                  <span
                    id='docerrormsg'
                    className='Spanerrormsgs'
                    style={{ textAlign: 'left', verticalAlign: 'bottom' }}
                  >
                    <p className='errormsg poppins-medium'>
                      Please Choose/Drag File(s) to upload.
                    </p>
                  </span>
                </div>
              )}
            </div>
          </div>
          
          {props?.hint && (
            <div tabIndex={0} aria-label={`Hint: ${props?.hint}`}
              className={
                props?.hintTextClassName ? props?.hintTextClassName : 'hintmsg'
              }
            >
              <span className={props?.hintClassName}>Hint:</span> {props?.hint}
            </div>
          )}
          {props?.note && (
            <div tabIndex={0} aria-label={`Note: ${props?.note}`}
              className={
                props?.hintTextClassName ? props?.hintTextClassName : 'hintmsg'
              }
            >
              <span className={props?.hintClassName}>Note:</span> {props?.note}
            </div>
          )}
        </div>
      </div>
      {showAlert ? (
        <Alert
          message={`File(s) with the name(s) ${existingFiles?.join(
            ', '
          )} already exists. Do you want to replace them?`}
          yes='Replace'
          cancel='Cancel'
          className='alert-info'
          btn1iconclassName='icon-checked  font-12 pe-1'
          btn2iconclassName='icon-close  font-10 pe-1'
          btn1className='btn-border-radius3 px-2 btn-primary whitetext poppins-medium font-12 btn-xs'
          btn2className='btn-border-radius3 px-2 color-primary btn-border2 poppins-medium font-12 btn-xs'
          onClick={onRespondClick}
        />
      ) : (
        ''
      )}
      {showAlert1 ? 
              <Alert
              message='Are you sure you want to remove the file?'
              alerttextclass="poppins-semibold font-12 text-center"
              yes='YES'
              cancel='NO'
              className='alert-info'
              btn1iconclassName='icon-checked  font-12 pe-1'
              btn2iconclassName='icon-close  font-10 pe-1'
              btn1className='btn-border-radius3 px-2 btn-primary whitetext poppins-semibold font-12  btn-xs'
              btn2className='btn-border-radius3 px-2 btn-border2 color-primary poppins-semibold font-12  btn-xs'
              onClick={onClickAlert}
            />
              : ''}
    </>
  )
}
FileUpload.propTypes = {
  onFileChange: PropTypes.func,
}
export default FileUpload
